import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { environment } from '@dp/environments/environment';
import { Observable } from 'rxjs';

import { MemberProfile } from '@lib/core/models/member.interface';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private http: HttpClient = inject(HttpClient);

  getMemberProfileByHelsiId(helsiId: string): Observable<MemberProfile> {
    return this.http.get<MemberProfile>(`${environment.protectedApiUrl}/members/by-helsi-id/${helsiId}`);
  }
}
